import React, { useState } from 'react';
import {  Form, Input, Button, message } from 'antd';
import { 
    UserOutlined, 
    LockOutlined, 
    RocketOutlined, 
    CloudServerOutlined, 
    SafetyCertificateOutlined, 
    AppstoreOutlined, 
    PieChartOutlined, 
    DeploymentUnitOutlined 
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import request from '../../utils/request';
import './Login.css';

const Login = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const res = await request.post('/admin/login', {
                username: values.username,
                password: values.password,
                account_type: 'ocean_engine',
            });

            if (res.code === 0) {
                message.success('登录成功');
                localStorage.setItem('user_token', res.data.user_token);
                localStorage.setItem('user_info', JSON.stringify(res.data.user_info));
                navigate('/');
            } else {
                message.error(res.message || '登录失败');
            }
        } catch (error) {
            console.error('Login failed:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            {/* 左侧品牌区域 */}
            <div className="login-left">
                <div className="login-left-content">
                    <div className="login-logo-top">
                        <div className="logo-icon-small">HM</div>
                        <span className="logo-text-small">鹤梦云生态管理平台</span>
                    </div>

                    <div className="hero-section">
                        <h1 className="hero-title">
                            为行业领导者打造的<br />
                            <span className="highlight">一站式物联网生态系统</span>
                        </h1>
                        <p className="hero-subtitle">赋能制造商、解决方案提供商和分销商</p>
                    </div>

                    <div className="feature-grid">
                        <div className="feature-card">
                            <div className="feature-icon-box"><DeploymentUnitOutlined /></div>
                            <div className="feature-info">
                                <h3>产品生命周期管理</h3>
                                <p>从产品构思到生命周期结束进行全面管理</p>
                            </div>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon-box"><CloudServerOutlined /></div>
                            <div className="feature-info">
                                <h3>无缝设备云集成</h3>
                                <p>将您的设备与我们强大的云基础设施集成</p>
                            </div>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon-box"><SafetyCertificateOutlined /></div>
                            <div className="feature-info">
                                <h3>安全的空中下载(OTA)更新</h3>
                                <p>安全高效地为您所有设备部署更新</p>
                            </div>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon-box"><AppstoreOutlined /></div>
                            <div className="feature-info">
                                <h3>自定义APP应用管理</h3>
                                <p>为您的生态开发和管理自定义应用程序</p>
                            </div>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon-box"><PieChartOutlined /></div>
                            <div className="feature-info">
                                <h3>分销商自动收益分润</h3>
                                <p>与您的分销合作伙伴自动分享收益</p>
                            </div>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon-box"><RocketOutlined /></div>
                            <div className="feature-info">
                                <h3>精准APP营销运营</h3>
                                <p>直接通过平台开展营销活动</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* 右侧登录表单 */}
            <div className="login-right">
                <div className="login-card-wrapper">
                    <div className="login-card">
                        <h1 className="login-welcome-title">欢迎回来！</h1>

                        <div className="login-tabs">
                            <span className="login-tab-item active">账号登录</span>
                        </div>

                        <Form
                            name="login_form"
                            className="login-form-body"
                            initialValues={{ remember: true }}
                            onFinish={onFinish}
                        >
                            <Form.Item
                                name="username"
                                rules={[{ required: true, message: '请输入账户名!' }]}
                            >
                                <Input
                                    prefix={<UserOutlined className="input-icon" />}
                                    placeholder="账号"
                                    size="large"
                                    className="login-input-themed"
                                />
                            </Form.Item>
                            
                            <Form.Item
                                name="password"
                                rules={[{ required: true, message: '请输入密码!' }]}
                            >
                                <Input.Password
                                    prefix={<LockOutlined className="input-icon" />}
                                    placeholder="密码"
                                    size="large"
                                    className="login-input-themed"
                                />
                            </Form.Item>

                            <div className="login-agreement-row">
                                <span className="agreement-text">
                                    登录视为您已阅读并同意鹤梦云<Button type="link" style={{ padding: 0 }}>用户协议</Button>和<Button type="link" style={{ padding: 0 }}>隐私政策</Button>
                                </span>
                            </div>

                            <Form.Item>
                                <Button type="primary" htmlType="submit" className="login-submit-btn" loading={loading} size="large">
                                    登录
                                </Button>
                            </Form.Item>

                            <div className="login-footer-links">
                                <span className="footer-left">还没有账号？<Button type="link" style={{ padding: 0 }}>立即注册</Button></span>
                                <Button type="link" className="footer-right" style={{ padding: 0 }}>忘记密码？</Button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
